import { createFileRoute } from '@tanstack/react-router'

interface IAllProductsSearch {
  page?: number
}

export const Route = createFileRoute('/_authenticated/all-products')({
  validateSearch: (search: Record<string, unknown>): IAllProductsSearch => ({
    page: Number(search.page) > 1 ? Number(search.page) : undefined,
  }),
})
